/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import $ from 'jquery'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import CRM from '../BaseComponent/CRM'
import jMoment from 'moment-jalaali'
import {Button} from '../OrderStatus/OrderList'
import FromToPicker from '../BaseComponent/FromToPicker'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import {loginVoip} from '../utils/callToCustomer'

class ListCRM extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      lengthProducts: 0,
      crmReport: [],
      modalDetails: false,
      detailsList: [],
      mediaList: [],
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      categoryList: [],
      subjectList: [],
      definitionList: [],
      priorityList: [],
      editModal: false,
      editableMediaList: [],
      editableCategoryList: [],
      editableSubjectList: [],
      editableDefinitionList: [],
      editablePriorityList: [],
      editableStatusList: [],
      statusList: [],
      fromDate: '',
      toDate: '',
      lastFromDate: '',
      lastToDate: '',
      showComment: '',
      showResponse: '',
      modalComment: false,
      selectedRow: [],
      buttonClicked: false,
      printInfo: [],
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'نام مشتری',
          value: 'name',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: ' جنسیت',
          value: 'messageContent',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد مشتری',
          value: 'customerCode',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'موبایل مشتری',
          value: 'mobile',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: true,
          direction: null,
          sortable: true
        },

        {
          name: 'شماره فاکتور',
          value: 'invoiceNum',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان ثبت',
          value: 'registrationTime',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'کاربر ثبت کننده',
          value: 'operatorName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان آخرین تغییر',
          value: 'lastChangeTimeStamp',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'آخرین وضعیت',
          value: 'contactStatusName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخچه تغییرات',
          value: 'changeHistory',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پردازش',
          value: 'process',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت مشاهده',
          value: 'seenStatus',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      operators: [],
      personId: '',
      customerCode: '',
      defaultValueDate: true
    }
  }

  getAllCrmReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${CRM.CRM_CONTACT_MASTER_LIST}`, {
        params: filter
      })

      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            tablePageNumber: this.state.pageNumber,
            tablePageSize: this.state.pageSize,
            crmReport: response.data.object.result,
            lengthProducts: response.data.object.countAll,
            buttonClicked: true,
            toPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
            fromPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          // message.error(response.data.description)
          this.setState({
            crmReport: [],
            loading: false
          })
        }
      })
  }

  componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search)
    var customerCode = urlParams.get('customerCode') === null ? '' : urlParams.get('customerCode')
    if (customerCode !== '') {
      this.setState(
        {
          customerCode,
          contactMediaId: '',
          defaultValueDate: false,
          fromDate: '',
          toDate: ''
        },
        () => {
          this.getAllCrmReport(false)
        }
      )
    } else {
      this.setState({contactMediaId: 1})
    }
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_MEDIA_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          mediaList: response.data.object,
          editableMediaList: response.data.object
        })
      } else {
        this.setState({
          mediaList: [],
          editableMediaList: []
        })
      }
    })

    http.get(`crm/contact/status/list`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          statusList: response.data.object,
          editableStatusList: response.data.object
        })
      } else {
        this.setState({
          statusList: [],
          editableStatusList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      if (response.data.error == null) {
        this.setState({
          categoryList: response.data.object,
          editableCategoryList: response.data.object
        })
      } else {
        this.setState({
          categoryList: [],
          editableCategoryList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          subjectList: response.data.object,
          editableSubjectList: response.data.object
        })
      } else {
        this.setState({
          subjectList: [],
          editableSubjectList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          definitionList: response.data.object,
          editableDefinitionList: response.data.object
        })
      } else {
        this.setState({
          definitionList: [],
          editableDefinitionList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_PRIORIRT_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response))
      if (response.data.error == null) {
        this.setState({
          priorityList: response.data.object,
          editablePriorityList: response.data.object
        })
      } else {
        this.setState({
          priorityList: [],
          editablePriorityList: []
        })
      }
    })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllCrmReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllCrmReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllCrmReport(false)
    }
  }

  changeDropDown(data) {
    this.setState({
      crmReport: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  onResultFetched(data) {
    this.setState({
      crmReport: data
    })
  }

  changeCategory(e) {
    let value = e.target.value

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          subjectList: response.data.object,
          editableSubjectList: response.data.object
        })
      } else {
        this.setState({
          subjectList: [],
          editableSubjectList: []
        })
      }
    })
  }

  changeSubject(e) {
    let value = e.target.value

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}?contactSubjectId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          definitionList: response.data.object,
          editableDefinitionList: response.data.object
        })
      } else {
        this.setState({
          definitionList: [],
          editableDefinitionList: []
        })
      }
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleLastChangeFromDate = (lastFromDate) => {
    this.setState({
      lastFromDate
    })
  }

  handleLastChangeToDate = (lastToDate) => {
    this.setState({
      lastToDate
    })
  }

  onResultFetchedDetails(data) {
    this.setState({
      detailsList: data
    })
  }

  showDetails = (numId) => {
    var id = numId
    this.setState({
      modalDetails: !this.state.modalDetails
    })
    http
      .get(
        `${CRM.CRM_CONTACT_DETAIL_LIST}?contactMasterId=${id}&pageNumber=1&pageSize=100&sortBy=changedTimeStamp_desc`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('detailId', id)
          this.setState({
            detailsList: response.data.object.result,
            detailsTotal: response.data.object.countAll
          })

          this.getAllCrmReport()
        } else {
          // message.error(response.data.description)
          this.setState({
            detailsList: []
          })
        }
      })
  }

  closeDetails = () => {
    this.setState({
      modalDetails: !this.state.modalDetails
    })
  }

  details = () => {
    this.setState({
      modalDetails: !this.state.modalDetails
    })
  }

  showEdit = (
    contactMasterId,
    contactCategoryId,
    contactDefinitionId,
    contactMediaId,
    contactPriorityId,
    contactStatusId,
    contactSubjectId,
    comment,
    response,
    action
  ) => {
    this.setState({
      editModal: !this.state.editModal,
      contactCategoryId,
      contactDefinitionId,
      contactMediaId,
      contactPriorityId,
      contactStatusId,
      contactSubjectId,
      comment,
      response,
      action
    })
    sessionStorage.setItem('contactMasterId', contactMasterId)

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${contactCategoryId}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          editableSubjectList: response.data.object
        })
      } else {
        this.setState({
          editableSubjectList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}?contactSubjectId=${contactSubjectId}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          editableDefinitionList: response.data.object
        })
      } else {
        this.setState({
          editableDefinitionList: []
        })
      }
    })
  }

  editToogle = () => {
    this.setState({
      editModal: !this.state.editModal
    })
  }
  closeEdit = () => {
    this.setState({
      editModal: !this.state.editModal
    })
  }

  EditOk = () => {
    var contactMasterId = sessionStorage.getItem('contactMasterId')
    var editMedia = document.getElementById('editMedia').value
    var editCat = document.getElementById('editCat').value
    var editSub = document.getElementById('editSub').value
    var editDef = document.getElementById('editDef').value
    var editPri = document.getElementById('editPri').value
    var editResponse = document.getElementById('editRes').value
    var editcontactAction = document.getElementById('editcontactAction').value
    var editCm = document.getElementById('editCm').value
    var status = document.getElementById('editStatus').value
    if (editCm == '') {
      message.error('دیدگاه را وارد کنید')
    } else {
      let data = {
        contactMasterId,
        contactMediaId: editMedia,
        contactCategoryId: editCat,
        contactSubjectId: editSub,
        contactDefinitionId: editDef,
        contactPriorityId: editPri,
        contactComment: editCm,
        contactStatusId: status,
        contactResponse: editResponse,
        contactAction: editcontactAction
      }

      http.post(`${CRM.CRM_CONTACT_MASTER_DETAIL_UPDATE}`, data, {}).then((response) => {
        if (response.data.description == null) {
          message.success('دیدگاه با موفقیت ویرایش شد')
          this.setState({
            editModal: !this.state.editModal
          })
          this.getAllCrmReport()
        } else {
          this.setState({
            editModal: !this.state.editModal
          })
          // message.error(response.data.description)
        }
      })
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    var fromTime = this.state.fromDate == null ? '' : this.state.fromDate
    var toTime = this.state.toDate == null ? '' : this.state.toDate

    var lastFromDate = this.state.lastFromDate == null ? '' : this.state.lastFromDate
    var lastToDate = this.state.lastToDate == null ? '' : this.state.lastToDate
    var firstName = document.getElementById('firstName').value.trim()
    var lastName = document.getElementById('lastName').value.trim()
    var mobile = document.getElementById('mobile').value.trim()
    var customerCode = document.getElementById('customerCode').value || this.state.customerCode
    var invoiceId = document.getElementById('invoiceId').value.trim()
    var invoiceNum = document.getElementById('invoiceNum').value.trim()
    var media = document.getElementById('media').value
    var seen = document.getElementById('seen').value
    var category = document.getElementById('category').value
    let personId = this.state.personId !== '' ? this.state.personId.personId : ''
    var priority = document.getElementById('priority').value
    var subject = document.getElementById('subject').value
    var status = document.getElementById('status').value
    var gender = document.getElementById('gender').value
    var definition = document.getElementById('definition').value
    var comment = document.getElementById('comment').value
    var contactResponse = document.getElementById('contactResponse').value
    var contactAction = document.getElementById('contactAction').value

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (fromTime !== '') {
      filter.contactRegistrationFrom = fromTime
    }
    if (toTime !== '') {
      filter.contactRegistrationTo = toTime
    }
    if (lastFromDate !== '') {
      filter.contactLastChangeFrom = lastFromDate
    }
    if (lastToDate !== '') {
      filter.contactLastChangeTo = lastToDate
    }
    if (firstName !== '') {
      filter.firstname = firstName
    }
    if (lastName !== '') {
      filter.lastname = lastName
    }
    if (mobile !== '') {
      filter.mobile = mobile
    }
    if (customerCode !== '') {
      filter.customerCode = customerCode
    }
    if (invoiceId !== '') {
      filter.invoiceId = invoiceId
    }
    if (invoiceNum !== '') {
      filter.invoiceNum = invoiceNum
    }
    if (media !== '') {
      filter.contactMediaId = media
    }
    if (seen !== '') {
      filter.contactSeen = seen
    }
    if (category !== '') {
      filter.contactCategoryId = category
    }
    if (personId !== '') {
      filter.personId = personId
    }
    if (priority !== '') {
      filter.contactPriorityId = priority
    }
    if (subject !== '') {
      filter.contactSubjectId = subject
    }
    if (gender !== '') {
      filter.gender = gender
    }
    if (definition !== '') {
      filter.contactDefinitionId = definition
    }
    if (status !== '') {
      filter.contactStatusId = status
    }
    if (comment !== '') {
      filter.contactComment = comment
    }
    if (contactResponse !== '') {
      filter.contactResponse = contactResponse
    }
    if (contactAction !== '') {
      filter.contactAction = contactAction
    }
    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getAllCrmReport(false)
        }
      )
    }
  }

  showComment = (comment, response, selectedRow) => {
    var selectedArray = []
    selectedArray.push(this.state.detailsList[selectedRow])

    this.setState({
      showComment: comment,
      showResponse: response,
      modalDetails: !this.state.modalDetails,
      modalComment: !this.state.modalConfirm,
      selectedRow: selectedArray
    })
  }

  toggleComment = () => {
    this.setState({
      showComment: '',
      showResponse: '',
      modalDetails: true,
      modalComment: false,
      selectedRow: []
    })
  }
  closeComment = () => {
    this.setState({
      showComment: '',
      showResponse: '',
      modalDetails: true,
      modalComment: false,
      selectedRow: []
    })
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })
    http
      .get(`${CRM.CRM_CONTACT_MASTER_LIST}`, {
        params: filter
      })

      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${CRM.CRM_CONTACT_MASTER_LIST}`, {
        params: filter
      })
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['registrationTime'] = jMoment(excelReport[i]['registrationTime']).format('jYY/jMM/jDD')
            excelReport[i]['lastChangeTimeStamp'] = jMoment(excelReport[i]['lastChangeTimeStamp']).format('jYY/jMM/jDD')
            excelReport[i]['name'] = excelReport[i]['firstName'] + excelReport[i]['lastName']

            if (excelReport[i]['gender'] == null) {
              excelReport[i]['gender'] = '-'
            } else if (excelReport[i]['gender']) {
              excelReport[i]['gender'] = 'زن'
            } else if (!excelReport[i]['gender']) {
              excelReport[i]['gender'] = 'مرد'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  changeEditableCat = (e) => {
    let value = e.target.value
    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          editableSubjectList: response.data.object
        })
      } else {
        this.setState({
          editableSubjectList: []
        })
      }
    })
  }
  changeEditableSub = (e) => {
    let value = e.target.value

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}?contactSubjectId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          editableDefinitionList: response.data.object
        })
      } else {
        this.setState({
          editableDefinitionList: []
        })
      }
    })
  }

  getValueOperator = (personId) => {
    if (personId === null) {
      this.setState({
        personId: ''
      })
    } else {
      this.setState({
        personId
      })
    }
  }

  callToCustomer = () => {
    // loginVoip().then(res => {
    //   alert(JSON.stringify(res))
    // })
  }

  render() {
    let {pageNumber, pageSize, lengthProducts, loading} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let params = sessionStorage.getItem('params')
    let reporterName = cookie.load('name')

    let excelColumns = [
      {title: 'نام شهر', value: 'cityName'},
      {title: 'عرض جغرافیایی', value: 'latitude'},
      {title: 'نام استان', value: 'provinceName'},
      {title: 'طول جغرافیایی', value: 'longitude'}
    ]
    let printCol = [
      'ردیف',
      'نام مشتری',
      'جنسیت',
      'کد مشتری',
      'موبایل مشتری',
      'شناسه فاکتور',
      'شماره فاکتور',
      'زمان ثبت',
      'کاربر ثبت',
      'زمان آخرین تغییر',
      'آخرین وضعیت'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست گزارشات ارتباط با مشتریان"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={11}
              rightColSpan={5}
              centerColSpan={1}
              leftColSpan={5}
              centerSection={''}
              rightSection={'تاریخ ثبت از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((crm, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{crm.firstName + ' ' + crm.lastName}</td>
                  <td>{crm.gender == null ? '-' : crm.gender == false ? 'زن' : 'مرد'}</td>
                  <td>{crm.customerCode}</td>
                  <td>{crm.mobile.replace(/\+98/g, '0')}</td>
                  <td>{crm.invoiceId}</td>
                  <td>{crm.invoiceNum}</td>
                  <td>{jMoment(crm.registrationTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>{crm.operatorName}</td>
                  <td>{jMoment(crm.lastChangeTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>
                    <span className="font-weight-bold" style={{color: '#fff'}}>
                      {crm.contactStatusName}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش ارتباط با مشتریان"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'name'}
                field={'name'}
                title={'نام مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'gender'}
                field={'gender'}
                title={'جنسیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'customerCode'}
                field={'customerCode'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mobile'}
                field={'mobile'}
                title={'موبایل مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceId'}
                field={'invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'registrationTime'}
                field={'registrationTime'}
                title={'تاریخ ثبت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'operatorName'}
                field={'operatorName'}
                title={'کاربر ثبت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'lastChangeTimeStamp'}
                field={'lastChangeTimeStamp'}
                title={'تاریخ آخرین تغییر'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'contactStatusName'}
                field={'contactStatusName'}
                title={'آخرین وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>کاربران</li>
            <li>نقش ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/CRM/add'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>

                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  defaulValue={this.state.defaultValueDate}
                  fromId="from"
                  toId="to"
                />

                <FromToPicker
                  onChangeFromDate={this.handleLastChangeFromDate}
                  onChangeToDate={this.handleLastChangeToDate}
                  fromLabel="تاریخ آخرین تغییر از"
                  toLabel="تاریخ آخرین تغییر تا"
                  defaulValue={false}
                  fromId="lastFrom"
                  toId="lastTo"
                />

                <div className="formComponent">
                  <label>نام</label>
                  <input type="text" className="form-control" id="firstName" />
                </div>

                <div className="formComponent">
                  <label>نام خانوادگی</label>
                  <input type="text" className="form-control" id="lastName" />
                </div>

                <div className="formComponent">
                  <label>موبایل</label>
                  <input type="text" className="form-control" id="mobile" />
                </div>

                <div className="formComponent">
                  <label>کد مشتری</label>
                  <input
                    onChange={(e) => this.setState({customerCode: e.target.value})}
                    type="text"
                    className="form-control"
                    id="customerCode"
                    defaultValue={this.state.customerCode}
                  />
                </div>

                <div className="formComponent">
                  <label>شناسه فاکتور</label>
                  <input type="text" className="form-control" id="invoiceId" />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور</label>
                  <input type="text" className="form-control" id="invoiceNum" />
                </div>

                <div className="formComponent">
                  <label>جنسیت : </label>
                  <select className="form-control" id="gender">
                    <option value="">----</option>
                    <option value={1}>مرد</option>
                    <option value={0}>زن</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت مشاهده : </label>
                  <select className="form-control" id="seen">
                    <option value="">----</option>
                    <option value={1}>مشاهده شده</option>
                    <option value={0}>مشاهده نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>رسانه تماس : </label>
                  <select className="form-control" id="media">
                    <option value="">------</option>

                    {this.state.mediaList.map((media, index) => (
                      <option
                        selected={media.contactMediaId == this.state.contactMediaId ? true : false}
                        value={media.contactMediaId}
                      >
                        {media.contactMediaName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label>خانواده تماس : </label>
                  <select className="form-control" id="category" onChange={this.changeCategory.bind(this)}>
                    <option value="">------</option>
                    {this.state.categoryList.map((category, index) => (
                      <option value={category.contactCategoryId}>{category.contactCategoryName}</option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>موضوع تماس : </label>
                  <select className="form-control" id="subject" onChange={this.changeSubject.bind(this)}>
                    <option value="">------</option>
                    {this.state.subjectList.map((subject, index) => (
                      <option value={subject.contactSubjectId}>{subject.contactSubjectName}</option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label>جزییات تماس : </label>

                  <select className="form-control" id="definition">
                    <option value="">------</option>
                    {this.state.definitionList.map((definition, index) => (
                      <option value={definition.contactDefinitionId}>{definition.contactDefinitionName}</option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>اولویت تماس : </label>
                  <select className="form-control" id="priority">
                    <option value="">------</option>
                    {this.state.priorityList.map((priority, index) => (
                      <option
                        selected={priority.contactPriorityId == '2' ? true : false}
                        value={priority.contactPriorityId}
                      >
                        {priority.contactPriorityName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت : </label>
                  <select className="form-control" id="status">
                    <option value="">------</option>
                    {this.state.statusList.map((priority, index) => (
                      <option value={priority.contactStatusId}>{priority.contactStatusName}</option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>دیدگاه مشتری</label>
                  <textarea type="text" className="form-control" id="comment" />
                </div>

                <div className="formComponent">
                  <label>پاسخ اپراتور</label>
                  <textarea type="text" className="form-control" id="contactResponse" />
                </div>
                <div className="formComponent">
                  <label>اقدام</label>
                  <textarea type="text" className="form-control" id="contactAction" />
                </div>
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getValueOperator}
                    lableText="کاربر ثبت کننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.crmReport.map((crm, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>{crm.firstName + ' ' + crm.lastName}</td>
                      <td>{crm.gender == null ? '-' : crm.gender == false ? 'زن' : 'مرد'}</td>
                      <td>{crm.customerCode}</td>
                      <td>
                        <button onClick={this.callToCustomer}>{crm.mobile.replace(/\+98/g, '0')}</button>
                      </td>
                      <td>{crm.invoiceId}</td>
                      <td>{crm.invoiceNum}</td>
                      <td>{jMoment(crm.registrationTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>{crm.operatorName}</td>
                      <td>{jMoment(crm.lastChangeTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td style={{background: crm.contactStatusColor}}>
                        <span className="font-weight-bold" style={{color: '#fff'}}>
                          {crm.contactStatusName}
                        </span>
                      </td>
                      <td>
                        <button className="details" onClick={() => this.showDetails(crm.contactMasterId)}>
                          <img src={require('../../image/details.svg')} alt="" />
                        </button>
                      </td>

                      <td>
                        <button
                          className="details"
                          onClick={() =>
                            this.showEdit(
                              crm.contactMasterId,
                              crm.contactCategoryId,
                              crm.contactDefinitionId,
                              crm.contactMediaId,
                              crm.contactPriorityId,
                              crm.contactStatusId,
                              crm.contactSubjectId,
                              crm.comment,
                              crm.response,
                              crm.action
                            )
                          }
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        {crm.seen ? (
                          <img src={require('../../image/read.svg')} alt="read" title={'مشاهده شده'} />
                        ) : (
                          <img src={require('../../image/unread.svg')} alt="unread" title={'مشاهده نشده'} />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProducts}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalDetails} toggle={this.details} size="lg">
          <ModalHeader toggle={this.details}>لیست تغییرات در این دیدگاه</ModalHeader>
          <ModalBody>
            <div>
              <table
                className="baseTable"
                style={this.state.detailsList.length == '0' ? {display: 'none'} : {diplay: 'block'}}
              >
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>کاربر مشاهده کننده</td>
                    <td>زمان آخرین تغییر</td>
                    <td>دیدگاه</td>
                    <td>پاسخ اپراتور</td>
                    <td>رسانه تماس</td>
                    <td>خانواده تماس</td>
                    <td>موضوع تماس</td>
                    <td>جزییات تماس</td>
                    <td>وضعیت</td>
                    <td>مشاهده دیدگاه</td>
                  </tr>
                  {this.state.detailsList.map((change, index) => (
                    <tr key={index + 'det'}>
                      <td>{index + 1}</td>
                      <td>{change.contactPersonName}</td>
                      <td>{jMoment(change.changedTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td title={change.comment === null ? '-' : change.comment}>
                        {change.comment.substr(0, 5) + '....'}
                      </td>
                      <td title={change.response === null ? '-' : change.response}>
                        {change.response === null ? '-' : change.response.substr(0, 5) + '....'}
                      </td>
                      <td>{change.contactMediaName}</td>
                      <td>{change.contactCategoryName}</td>
                      <td>{change.contactSubjectName}</td>
                      <td>{change.contactDefinitionName}</td>
                      <td>{change.contactStatusName}</td>
                      <td>
                        <button
                          className="details"
                          onClick={() => this.showComment(change.comment, change.response, index)}
                        >
                          <img src={require('../../image/tap.svg')} alt="hand" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/*<div className="paginationWrapp">*/}
              {/*  <Pageing*/}
              {/*    defaultCurrent={1}*/}
              {/*    getPage={this.getPageNumber}*/}
              {/*    pageSize={this.state.pageSize}*/}
              {/*    currentPage={this.state.pageNumber}*/}
              {/*    total={this.state.lengthProducts}*/}
              {/*  />*/}
              {/*</div>*/}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.closeDetails}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.editModal} toggle={this.editToogle} size="lg">
          <ModalHeader toggle={this.editToogle}>ویرایش</ModalHeader>
          <ModalBody>
            <div className="editModalForm">
              <div className="crmComponent">
                <label>رسانه تماس : </label>
                <select id="editMedia" className="form-control">
                  {this.state.editableMediaList.map((media, index) => (
                    <option
                      selected={this.state.contactMediaId === media.contactMediaId ? true : false}
                      value={media.contactMediaId}
                    >
                      {media.contactMediaName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="crmComponent">
                <label>خانواده تماس : </label>
                <select id="editCat" onChange={this.changeEditableCat.bind(this)} className="form-control">
                  {this.state.editableCategoryList.map((category, index) => (
                    <option
                      selected={this.state.contactCategoryId === category.contactCategoryId ? true : false}
                      value={category.contactCategoryId}
                    >
                      {category.contactCategoryName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="crmComponent">
                <label>موضوع تماس : </label>
                <select id="editSub" onChange={this.changeEditableSub.bind(this)} className="form-control">
                  {this.state.editableSubjectList.map((subject, index) => (
                    <option
                      selected={this.state.contactSubjectId === subject.contactSubjectId ? true : false}
                      value={subject.contactSubjectId}
                    >
                      {subject.contactSubjectName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="crmComponent">
                <label>جزییات تماس : </label>
                <select id="editDef" className="form-control">
                  {this.state.editableDefinitionList.map((definition, index) => (
                    <option
                      selected={this.state.contactDefinitionId === definition.contactDefinitionId ? true : false}
                      value={this.state.contactDefinitionId}
                    >
                      {definition.contactDefinitionName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="crmComponent">
                <label>اولویت تماس : </label>
                <select id="editPri" className="form-control">
                  {this.state.editablePriorityList.map((priority, index) => (
                    <option
                      selected={this.state.contactPriorityId == priority.contactPriorityId ? true : false}
                      value={priority.contactPriorityId}
                    >
                      {priority.contactPriorityName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="crmComponent">
                <label>وضعیت : </label>
                <select className="form-control" id="editStatus">
                  {this.state.editableStatusList.map((priority, index) => (
                    <option
                      selected={Number(this.state.contactStatusId) === Number(priority.contactStatusId) ? true : false}
                      value={priority.contactStatusId}
                    >
                      {priority.contactStatusName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="bottomCrmComponent">
              <label>دیدگاه : </label>
              <textarea id="editCm" defaultValue={this.state.comment} className="form-control" />
            </div>
            <div className="bottomCrmComponent">
              <label>پاسخ : </label>
              <textarea id="editRes" defaultValue={this.state.response} className="form-control" />
            </div>
            <div className="bottomCrmComponent">
              <label>اقدام : </label>
              <textarea id="editcontactAction" defaultValue={this.state.action} className="form-control" />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.EditOk}>
              ویرایش
            </button>
            <button className="cancelBtnModal" onClick={this.closeEdit}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalComment} toggle={this.toggleComment} size="md">
          <ModalHeader toggle={this.toggleComment}>مشاهده دیدگاه کاربر و پاسخ اپراتور</ModalHeader>
          <ModalBody>
            <div className="commentCrm">
              <div>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>زمان آخرین تغییر</td>
                      <td>رسانه تماس</td>
                      <td>خانواده تماس</td>
                      <td>موضوع تماس</td>
                      <td>جزییات تماس</td>
                      <td>وضعیت</td>
                    </tr>
                    {this.state.selectedRow.map((change, index) => (
                      <tr key={index + 'det'}>
                        <td>{jMoment(change.changedTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                        <td>{change.contactMediaName}</td>
                        <td>{change.contactCategoryName}</td>
                        <td>{change.contactSubjectName}</td>
                        <td>{change.contactDefinitionName}</td>
                        <td>{change.contactStatusName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="formComponent">
                <label>دیدگاه کاربر : </label>
                <p>{this.state.showComment}</p>
              </div>
              <div className="formComponent">
                <label>پاسخ اپراتور : </label>
                <p>{this.state.showResponse}</p>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.closeComment}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ListCRM
